module.exports = require("superstruct");